<template>
  <div id="app">
    <div class="main-wrapper main-wrapper-1">
      <div class="navbar-bg"></div>
      <nav class="navbar navbar-expand-lg main-navbar">
        <div class="form-inline mr-auto">
          <!-- <ul class="navbar-nav mr-3">
            <li><a href="#" data-toggle="sidebar" class="nav-link nav-link-lg collapse-btn"><i
                  class="fas fa-bars"></i></a></li>
          </ul> -->
        </div>
        <ul class="navbar-nav navbar-right">          
          <li class="dropdown"><a href="#" data-toggle="dropdown"
              class="nav-link dropdown-toggle nav-link-lg nav-link-user">
              <img alt="image" src="images/admin.png" class="user-img-radious-style">
              <span class="d-sm-none d-lg-inline-block"></span></a>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-title">{{name}}</div>
              <router-link to="/profile" class="dropdown-item has-icon" >
                <i class="fas fa-user"></i> Profile
              </router-link>
              <router-link to="/changepass" class="dropdown-item has-icon" >
                <i class="fas fa-key"></i> Change Password
              </router-link>
              <div class="dropdown-divider"></div>
              <a v-on:click="logout" class="dropdown-item has-icon text-danger">
                <i class="fas fa-sign-out-alt"></i> Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      <div class="main-sidebar sidebar-style-2">
        <aside id="sidebar-wrapper">
          <div class="sidebar-brand">
            <router-link to="/dashboard"  >
              <img alt="image" src="images/logo.jpg" class="header-logo" />
              <span class="logo-name" style="color: black;">P2P Parking</span>
            </router-link>
          </div>
          <ul class="sidebar-menu">
            <li class="dropdown">
              <router-link to="/dashboard" active-class="active" class="nav-link" aria-hidden='true'
                ><i class="fas fa-home"></i><span>Dashboard</span></router-link
              >
            </li>
            <li class="dropdown ">
              <router-link to="/users" active-class="active"  class="nav-link" aria-hidden='true'
                ><i class="fas fa-user-check"></i><span>Verified Users</span></router-link>
            </li>
            <li class="dropdown ">
              <router-link to="/requested_users" active-class="active"  class="nav-link" aria-hidden='true'
                ><i class="fas fa-user-plus"></i><span>Requested Users</span></router-link>
            </li>

            <li class="dropdown">
              <router-link to="/parking" active-class="active" class="nav-link" aria-hidden='true'
              ><i class="fas fa-car-side"></i><span>Parking Management</span></router-link>
            </li>
            <li class="dropdown">
              <router-link to="/request" active-class="active" class="nav-link" aria-hidden='true'
              ><i class="fas fa-car"></i><span>Parking Requests</span></router-link>
            </li>
            <li class="dropdown">
              <router-link to="/notification" active-class="active" class="nav-link"
              ><i class="fas fa-bell"></i><span>Notification</span></router-link>
            </li>
            <li class="dropdown">
              <router-link to="/payment_history" active-class="active" class="nav-link"
              ><i class="far fa-credit-card"></i><span>Payment History</span></router-link>
            </li>
            <li class="dropdown">
              <router-link to="/content" active-class="active" class="nav-link"
              ><i class="fas fa-file"></i><span>Contents</span></router-link>
            </li>
            <li class="dropdown">
              <router-link to="/support" active-class="active" class="nav-link"
              ><i class="fas fa-file"></i><span>Support</span></router-link>
            </li>
          </ul>
        </aside>
      </div>
    </div>
  </div>
  
  <div
        class="modal fade change-password-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Change Password</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="cross()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Old Password</label>
                    <input type="text" v-if="showPassword1" v-model="old_password" @keyup="validateOldPass" class="form-control" />
                    <input type="password" v-else v-model="old_password" @keyup="validateOldPass" class="form-control" />
                    <i class="fas" @click="toggleShow1" :class="{ 'fa-eye': showPassword1, 'fa-eye-slash' : !showPassword1 }"></i>
                  </div>
                <div v-if="op_error" class="alert">{{ op_error }}</div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>New Password</label>
                    <input type="text" v-if="showPassword2" v-model="password" @keyup="validatePass" class="form-control" />
                    <input type="password" v-else v-model="password" @keyup="validatePass" class="form-control" />
                    <i class="fas" @click="toggleShow2" :class="{ 'fa-eye': showPassword2, 'fa-eye-slash' : !showPassword2 }"></i>
                  </div>
                <div v-if="p_error" class="alert">{{ p_error }}</div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Confirm Password</label>
                    <input type="text" v-if="showPassword3" v-model="password_confirmation" @keyup="validateConfirmPass" class="form-control" />
                    <input type="password" v-else v-model="password_confirmation" @keyup="validateConfirmPass" class="form-control" />
                    <i class="fas" @click="toggleShow3" :class="{ 'fa-eye': showPassword3, 'fa-eye-slash' : !showPassword3 }"></i>
                  </div>
                <div v-if="pc_error" class="alert">{{ pc_error }}</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <input type="button" @click="changepass" value="Save" class="modal-btn" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

</template>


<script>
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import axios from "../services/customAxios";
import { base_url } from "../config";
// import moment from 'moment';
// import jwt_decode from "jwt-decode";
export default defineComponent({
  name: "Dashboard",
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data(){
    return{
      result:[],   
      name:"",    
      email:"",    
      op_error:"",
      p_error:"",
      pc_error:"",
      old_password: "",
      password: "",
      password_confirmation: "",
      base_url: base_url,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
    }
  },
  methods: {
    toggleShow1() {
      this.showPassword1 = !this.showPassword1
    },
     toggleShow2() {
      this.showPassword2 = !this.showPassword2
    },
     toggleShow3() {
      this.showPassword3 = !this.showPassword3
    },
    logout() {
      if(confirm("Are you Sure you want to Logout?")){
      localStorage.clear();
      this.$router.push({ name: "Login" });
      // console.log("LoggedOut");
      }
    },
    async LoadProfile() {
      let response = await axios.get(`${base_url}/get_admin`); 
      console.log("======ehfiuewhfeoifhdew====>>>>>",response.data.result);
      this.name = response.data.result[0].name;
      console.log("this.name",this.name)
      this.email = response.data.result[0].email;
      localStorage.setItem('email', this.email)
      // this.showLoader = false;
    },
    async changepass() {
      try{
      let response = await axios.put(`${base_url}/change_password`,
        {
          old_password: this.old_password,
          password: this.password,
          password_confirmation: this.password_confirmation,
        }
      );
      createToast({title: "Success", description: response.data.message},{type: "success"})
      if(response.data.success == true){
        this.$router.push('/dashboard')
       }
        // console.log("check result==>", response.data.result);
      } 
      catch(error){
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },  
   cross(){
    window.location.reload();
   },
    validateOldPass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.old_password)) {
          this.op_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.op_error = '';
      }
    },
    validatePass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.password)) {
          this.p_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.p_error = '';
      }
    },
    validateConfirmPass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.password_confirmation)) {
          this.pc_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.pc_error = '';
      }
    },
  },
   mounted() {
    this.LoadProfile();
    let admin = localStorage.getItem("token");

    // let decoded = jwt_decode(admin);
    // let getExpiration = moment.unix(decoded.exp);
    // let isAuthencated = moment().isBefore(getExpiration);
    // console.log("======>", getExpiration);   
    // console.log("======>isAuthencated", isAuthencated);   
    // if (!isAuthencated) {
    //   localStorage.clear();
    //   this.$router.push({ name: "Login" });
    // }

    if (!admin) {
      this.$router.push({ name: "Login" });
    }
  }
});
</script>   

<style>
nav.navbar.navbar-expand-lg.main-navbar {
    width: 82%;
}

.custom-table {
  padding: 20px;
}
.custom-table ul {
  padding: 0px;
  margin: 0px;
  display: flex;
  text-align: left;
}
.custom-table ul li{
  list-style: none;
}
.custom-table ul li:nth-child(1) {
  font-weight: bold;
  color: #3d5d60;
  width: 40%;
}
</style>
<style scoped>
i.fas.fa-eye-slash,
i.fas.fa-eye {
   position: absolute;
    top: 60%;
    transform: translate(-50%, -50%);
    color: #3a494b;
    right: 16px;
    z-index:99
}
.form-group {
    position: relative;
}

i.fas.fa-eye-slash {
    top: 52px !important;
}
i.fas.fa-eye {
    top: 52px !important;
}
</style>